export default function PHP_strrev() {
  return (
    <div>
      <h1>PHP_strrev</h1>
    </div>
  );
}
